import { createGlobalStyle } from "styled-components"

import theme from "../theme"

export const DefaultGlobalStyle = createGlobalStyle`

    :root {
      font-size: 100%;
    
        html, body {
          display: flex;
          flex-direction: column;
          height: 100%;
          margin: 0;
          padding: 0;
          font-size: 16px;
          font-family: -apple-system, BlinkMacSystemFont, "Arial Nova", "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
          scroll-behavior: smooth;
          background: ${theme.bg.default};
        }
           
    }
`
